import React from "react";
import { Banner, EmptyBanner } from "../../stores/BannerStore";
import { isEmptyBanner } from "../../utils/BannerUtil";
import { renderBannerTeaser } from "./Teaser";

type PropType = {
    banner: Banner | EmptyBanner;
};
class TileBanner extends React.Component<PropType> {
    renderBanner(banner: Banner) {
        //const firstImage = banner.images[0];

        return (
            <div className="mfcss-tile-banner">
                <div className="test-ex-banner-loaded">
                    {renderBannerTeaser(banner, { className: "mfcss_teaser-tile-Banner" })}
                </div>
            </div>
        );
    }
    render() {
        const banner = this.props.banner;
        if (isEmptyBanner(banner)) {
            return null;
        }
        return this.renderBanner(banner as Banner);
    }
}

export default TileBanner;
